import React, { Component } from "react"
import { connect } from 'react-redux'
import {
    updateGR_ServiceAction,
    updateGR_ServiceLineAction,
    updateGR_ServiceAccountAssignmentAction
} from '../../redux/actions/GRAction'
import {
    getPODetailOriginalAction,
} from '../../redux/actions/MainAction'
import {
    EVENT_GET_PO_SERVICE_ORIGINAL
} from '../../configs/EventTypes'
class AddServiceItemModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props,
            clickCnt: null
        }

        window.emitter.addListener(EVENT_GET_PO_SERVICE_ORIGINAL, this.getPOOriginal.bind(this))
    }
    componentWillReceiveProps(nextProps) {
        this.setState({clickCnt: null})
    }


    async copyItem(datas) {
        let { clickCnt } = this.state
        clickCnt = clickCnt == null ? 1 : clickCnt + 1
        if (clickCnt == 1) {
            const { t_GR_SERVICE,
                t_GR_SERVICELINE,
                t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
                po_original, updateGR_Service,
                t_GR_ITEM
            } = this.props

            let item_curent = t_GR_SERVICE;
            let item_no_all = [];

            let item_index_next = item_curent.length;

            item_curent.forEach(element => {
                item_no_all.push(element.service_item_no)
            });

            item_no_all.sort(function (a, b) { return b - a });
            let item_no_next = Number(item_no_all[0]) + 1;

            let item_no = t_GR_ITEM.filter((data) => {
                return data.item_no && data.item_no.toString() === item_no_next.toString()
            })
            if (item_no && item_no.length > 0) {

                let item_curent = t_GR_ITEM;
                let item_no_all = [];
                item_curent.forEach(element => {
                    item_no_all.push(element.item_no)
                });
                item_no_all.sort(function (a, b) { return b - a });
                item_no_next = Number(item_no_all[0]) + 1;
            }

            let choose_service_item_no = datas.service_item_no;
            let item_new = datas;
            let contract_item_no = item_new.service_item_no;

            item_new.contract_item_no = contract_item_no;
            item_new.service_item_id = item_no_next;
            item_new.service_item_no = item_no_next;
            item_new.checked = 1;

            let objservice = t_GR_SERVICE.find(s => s.checked)
            if (typeof (objservice) !== "undefined") {
                item_new.requisitioner = objservice.requisitioner
            }

            updateGR_Service(item_new);

            let local_t_GR_SERVICELINE = [...t_GR_SERVICELINE]

            po_original.t_GR_SERVICELINE && po_original.t_GR_SERVICELINE.map((row, index) => {
                if (Number(row.service_item_no) === Number(choose_service_item_no)) {
                    let item = { ...row }
                    item.service_item_no = item_no_next;
                    //item.checked = 1
                    local_t_GR_SERVICELINE.push(item)

                }
            })

            await this.props.updateGR_ServiceLine(local_t_GR_SERVICELINE, "", "", true)

            let local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT = [...t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT]
            po_original.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.forEach(function (element) {
                if (element.item_no == choose_service_item_no) {
                    let itemAcc = { ...element }
                    itemAcc.item_no = item_no_next;
                    local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.push(itemAcc)
                }
            });
            this.props.updateGR_ServiceAccountAssignment(local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT, "", "", true)

            let choose_item = {};
            choose_item.action = "copy";
            choose_item.data = item_new;
            window.onShowServiceline("", item_index_next, "t_GR_SERVICE", "selected_serviceItem", choose_item)
        }
        this.setState({clickCnt: clickCnt})
    }
    getPOOriginal(object) {
        if (object) {
            this.props.getPODetailOriginal(object.po_no, object.unitCode, object.userId);
        }
    }


    render() {

        const { po_original } = this.props;
        let t_GR_SERVICE = po_original.t_GR_SERVICE;

        return (
            <div className="modal fade sp-modal rrs-modal" id="AddServiceItemModal" tabIndex={-1} role="dialog" aria-labelledby="AddServiceItemModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="AddServiceItemModalLabel">เพิ่มรายการรับบริการ</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body rrs-container">
                            <div className="rrs-detail3">
                                <div className="row no-gutters sp-table-content">
                                    <div className="col-12">
                                        <table className="sp-table table rrs-table-2">

                                            <thead>
                                                <tr className="sp-table-header">
                                                    <th className="sp-table-header" width="5%"><div className="th-text">A</div></th>
                                                    <th className="th-table" width="5%"><div className="th-text">I</div></th>
                                                    <th className="th-table"><div className="th-text">Material</div></th>
                                                    <th className="th-table"><div className="th-text">Short Text</div></th>
                                                    <th className="th-table" width="5%"><div className="th-text">Action</div></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    t_GR_SERVICE && t_GR_SERVICE.map((datas, index) => (
                                                        <tr key={index}>
                                                            <td>{datas.a}</td>
                                                            <td>{datas.i}</td>
                                                            <td>{datas.material}</td>
                                                            <td>{datas.short_text}</td>
                                                            <td>
                                                                <button className="btn btn-info btn-choose-item" data-dismiss="modal" aria-label="Close" onClick={() => this.copyItem(datas)}>
                                                                    เลือก
                                                        </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux } = state
    return {
        po_original: MainRedux.po_original,
        t_GR_SERVICE: MainRedux.t_GR_SERVICE,
        t_GR_SERVICELINE: MainRedux.t_GR_SERVICELINE,
        t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: MainRedux.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
        t_GR_ITEM: MainRedux.t_GR_ITEM,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateGR_Service: (data, index = "", fieldName = "") => dispatch(updateGR_ServiceAction(data, index, fieldName)),
        updateGR_ServiceLine: (data, index = "", fieldName = "", clear = false) => dispatch(updateGR_ServiceLineAction(data, index, fieldName, clear)),
        updateGR_ServiceAccountAssignment: (data, index = "", fieldName = "", clear = false) => dispatch(updateGR_ServiceAccountAssignmentAction(data, index, fieldName, clear)),
        getPODetailOriginal: (poNo, unitCode, userId) => dispatch(getPODetailOriginalAction(poNo, unitCode, userId)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddServiceItemModal)